export default __webpack_public_path__ + "static/media/home.af2764b9.mp4";